import { Account } from 'store/account/account.types';

const useHasAddress = (account: Account) => {
  return !!account?.country;
};

export default useHasAddress;
